import React, { useState, useEffect } from 'react';

// Services
import { formationSessionStatuses } from 'services/constants';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// ------------------------------ SELECT FORMATION SESSION STATUSES ----------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectFormationSessionStatuses = ({ statuses, setStatuses }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(formationSessionStatuses.map(s => ({ label: s.label, value: s.value })));
    }, []);

    return (
        <SelectMultiple
            value={statuses}
            onChange={value => setStatuses(value)}
            options={options}
            placeholder="Statut"
        />
    );
};

export default SelectFormationSessionStatuses;
